var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2598_6200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2969 18.022L11.7235 10.022H13.9527L12.5706 18.022H10.2969Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2969 18.022L12.1248 10.022H13.9527L12.5706 18.022H10.2969Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6416 10.1114C20.1958 9.93364 19.4824 9.75586 18.5908 9.75586C16.3616 9.75586 14.7566 10.867 14.7566 12.467C14.7566 13.667 15.8712 14.2892 16.7628 14.6892C17.6545 15.0892 17.922 15.3559 17.922 15.7114C17.922 16.2447 17.2087 16.5114 16.5845 16.5114C15.6928 16.5114 15.2024 16.3781 14.4445 16.067L14.1324 15.9336L13.8203 17.7559C14.3553 17.9781 15.3362 18.2003 16.3616 18.2003C18.7245 18.2003 20.2849 17.0892 20.2849 15.4003C20.2849 14.467 19.7053 13.7559 18.3678 13.1781C17.5653 12.7781 17.0749 12.5559 17.0749 12.1559C17.0749 11.8003 17.4762 11.4447 18.3678 11.4447C19.1258 11.4447 19.6608 11.5781 20.062 11.7559L20.2849 11.8447L20.6416 10.1114Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6416 10.1114C20.1958 9.93364 19.4824 9.75586 18.5908 9.75586C16.3616 9.75586 15.1578 10.867 15.1578 12.467C15.1578 13.667 15.8712 14.2892 16.7628 14.6892C17.6545 15.0892 17.922 15.3559 17.922 15.7114C17.922 16.2447 17.2087 16.5114 16.5845 16.5114C15.6928 16.5114 15.2024 16.3781 14.4445 16.067L14.1324 15.9336L13.8203 17.7559C14.3553 17.9781 15.3362 18.2003 16.3616 18.2003C18.7245 18.2003 20.2849 17.0892 20.2849 15.4003C20.2849 14.467 19.7053 13.7559 18.3678 13.1781C17.5653 12.7781 17.0749 12.5559 17.0749 12.1559C17.0749 11.8003 17.4762 11.4447 18.3678 11.4447C19.1258 11.4447 19.6608 11.5781 20.062 11.7559L20.2849 11.8447L20.6416 10.1114Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4756 10.022C23.9406 10.022 23.5393 10.0664 23.3164 10.5998L19.9727 18.022H22.3802L22.826 16.6886H25.6793L25.9468 18.022H28.0868L26.2143 10.022H24.4756V10.022ZM23.4502 15.3553C23.5839 14.9553 24.3418 12.9998 24.3418 12.9998C24.3418 12.9998 24.5202 12.5109 24.6539 12.1998L24.7877 12.9553C24.7877 12.9553 25.2335 14.9553 25.3227 15.3998H23.4502V15.3553Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0106 10.022C24.4756 10.022 24.0743 10.0664 23.8514 10.5998L19.9727 18.022H22.3802L22.826 16.6886H25.6793L25.9468 18.022H28.0868L26.2143 10.022H25.0106V10.022ZM23.4502 15.3553C23.6285 14.9109 24.3418 12.9998 24.3418 12.9998C24.3418 12.9998 24.5202 12.5109 24.6539 12.1998L24.7877 12.9553C24.7877 12.9553 25.2335 14.9553 25.3227 15.3998H23.4502V15.3553Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19924 15.623L5.97632 14.4674C5.57507 13.1341 4.28214 11.6674 2.85547 10.9563L4.86173 18.0674H7.26924L10.8805 10.0674H8.473L6.19924 15.623Z",
    fill: "#3C58BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.19924 15.623L5.97632 14.4674C5.57507 13.1341 4.28214 11.6674 2.85547 10.9563L4.86173 18.0674H7.26924L10.8805 10.0674H8.91883L6.19924 15.623Z",
    fill: "#293688"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.022L0.401252 10.1109C3.2546 10.7775 5.21628 12.4664 5.9742 14.4664L5.1717 10.6886C5.03794 10.1553 4.63669 10.022 4.14627 10.022H0V10.022Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.022C2.85335 10.6886 5.21628 12.422 5.9742 14.422L5.21628 11.2664C5.08253 10.7331 4.63669 10.422 4.14627 10.422L0 10.022Z",
    fill: "#F7981D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.022C2.85335 10.6886 5.21628 12.422 5.9742 14.422L5.4392 12.6886C5.30545 12.1553 5.12711 11.622 4.50294 11.3998L0 10.022Z",
    fill: "#ED7C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2598_6200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.0877,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.23929e02ad52aa3ad90c325bb4c38891.svg";
export { ForwardRef as ReactComponent };